import React, { useEffect, useState } from "react";

import { CountriesBareForm, CountriesPresets } from "@components/Screen/CountryBlocks";

export default function Countries({ apiData, setApiData }) {
    const [countriesLocked, setCountriesLocked] = useState(false);

    useEffect(() => {
        if (apiData?.forms_data?.main.fields) {
            const disabled_countries = Object.keys(apiData.forms_data.main.fields).filter((k) => {
                return apiData.forms_data.main.fields[k].disabled === true;
            });
            if (disabled_countries.length === Object.keys(apiData.forms_data.main.fields).length) {
                setTimeout(() => {
                    setCountriesLocked(true); // без таймаута не успевает отработать scroll_to_top для google-chrome
                }, 700);
            }
        }
    }, [apiData?.forms_data?.main.fields]);

    if (!apiData) return;

    return (
        <>
            <CountriesPresets
                apiData={apiData}
                setApiData={setApiData}
                disabled={countriesLocked}
                getPresetData={(data) => data.countries_data.preset}
                prefix={"countries"}
            />
            <hr />
            <CountriesBareForm prefix="countries" apiData={apiData} setApiData={setApiData} />
        </>
    );
}
